import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f624b9fa&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f624b9fa')) {
      api.createRecord('f624b9fa', component.options)
    } else {
      api.reload('f624b9fa', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f624b9fa&", function () {
      api.rerender('f624b9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bVzqE6EeESP4/JS/offershelp.vue"
export default component.exports